import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogBackdrop, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { FieldLabel } from '@systemeio/ui';
import { NotificationMenuMobile } from 'modules/notifications/components/notifications-menu-mobile';
import { useRouter } from 'next/router';
import React, { Fragment, useEffect } from 'react';
import SideMenuItem from 'shared/components/header/components/side-menu/components/side-menu-item';
import WorkspaceSelector from 'shared/components/header/components/workspace-selector';
import { useMenuItems } from 'shared/components/header/hooks/use-menu-items';
import { MobileLanguageSwitcher } from 'shared/components/language-switcher/mobile-language-switcher';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { ScreenHeightDiv } from 'shared/components/screen-height-div';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { SubAccountSelector } from '../sub-account-selector';
import { ArrowLeftIcon, BurgerIcon, LogoutIcon, OpenInNewIcon } from '@systemeio/ui/icons';
import { hasSubAccounts } from 'shared/hooks/use-user/utils/has-subaccounts';
import { twJoin } from 'tailwind-merge';
interface SideMenuProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const SideMenu = t0 => {
  const $ = _c(78);
  const {
    isOpen,
    setIsOpen
  } = t0;
  const {
    isWorkspaceOwner,
    user,
    isLoading,
    isDisabled,
    isSupportImpersonation,
    shouldShowSubAccountPage,
    avatarUrl
  } = useUser();
  const {
    menuItems
  } = useMenuItems();
  const {
    t
  } = useLocoTranslation();
  const {
    pathname
  } = useRouter();
  const isSettingsPage = pathname.includes("/profile");
  const isSubaccountPage = pathname.includes("/subaccounts");
  const hasWorkspaces = user?.workspaceMemberships && Array.isArray(user.workspaceMemberships) && user.workspaceMemberships.length > 0;
  let t1;
  if ($[0] !== setIsOpen) {
    t1 = () => {
      setIsOpen(false);
    };
    $[0] = setIsOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== pathname || $[3] !== setIsOpen) {
    t2 = [pathname, setIsOpen];
    $[2] = pathname;
    $[3] = setIsOpen;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  const t3 = `${isLoading && "animate-pulse"} flex w-full items-center justify-end gap-5`;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <NotificationMenuMobile />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== setIsOpen) {
    t5 = () => setIsOpen(true);
    $[6] = setIsOpen;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <BurgerIcon className="h-8 w-8" />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isLoading || $[10] !== t5) {
    t7 = <button disabled={isLoading} aria-label="Open Menu" onClick={t5}>{t6}</button>;
    $[9] = isLoading;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const T0 = Transition;
  const t8 = Fragment;
  const T1 = Dialog;
  const t9 = "fixed inset-0 z-10";
  let t10;
  if ($[12] !== setIsOpen) {
    t10 = () => setIsOpen(false);
    $[12] = setIsOpen;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <TransitionChild as={Fragment} enter="ease duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0"><DialogBackdrop className="fixed inset-0 bg-black/50" /></TransitionChild>;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const T2 = TransitionChild;
  const t12 = Fragment;
  const t13 = "ease-out duration-300";
  const t14 = "opacity-0 translate-x-full";
  const t15 = "opacity-100 translate-x-0";
  const t16 = "ease-in duration-200";
  const t17 = "opacity-100 translate-x-0";
  const t18 = "opacity-0 translate-x-full";
  const T3 = DialogPanel;
  const T4 = ScreenHeightDiv;
  const t19 = "bg-background-secondary text-text-primary fixed right-0 top-0 z-10 flex min-w-[17rem] max-w-[350px]  flex-col overflow-auto px-4 py-5";
  let t20;
  if ($[15] !== setIsOpen) {
    t20 = () => setIsOpen(false);
    $[15] = setIsOpen;
    $[16] = t20;
  } else {
    t20 = $[16];
  }
  let t21;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <ArrowLeftIcon className="stroke-text-primary" />;
    $[17] = t21;
  } else {
    t21 = $[17];
  }
  let t22;
  if ($[18] !== t) {
    t22 = t("global.back_to_page");
    $[18] = t;
    $[19] = t22;
  } else {
    t22 = $[19];
  }
  let t23;
  if ($[20] !== t22) {
    t23 = <span>{t22}</span>;
    $[20] = t22;
    $[21] = t23;
  } else {
    t23 = $[21];
  }
  let t24;
  if ($[22] !== t20 || $[23] !== t23) {
    t24 = <div onClick={t20} className="flex w-fit cursor-pointer items-center gap-2">{t21}{t23}</div>;
    $[22] = t20;
    $[23] = t23;
    $[24] = t24;
  } else {
    t24 = $[24];
  }
  const t25 = !isDisabled && user && <div className="flex flex-col gap-3.5 py-6"><div className="flex justify-between gap-3.5">{isWorkspaceOwner ? <div className="flex items-center gap-3.5"><img className="h-10 w-10 overflow-hidden rounded-full object-cover" src={avatarUrl} alt={`${user.firstName} ${user.lastName}`} /><div className="flex flex-col"><span className="text-base font-semibold">{user.firstName} {user.lastName}</span><LinkWithoutPrefetch href="/profile/user-settings" className={twJoin(isSettingsPage && "text-brand-primary")}>{t("global.settings")}</LinkWithoutPrefetch>{!hasSubAccounts(user) && shouldShowSubAccountPage && <LinkWithoutPrefetch className={twJoin(isSubaccountPage && "text-brand-primary")} href="/subaccounts">{t("header.user.profile.menu.sub_accounts")}</LinkWithoutPrefetch>}</div></div> : <div className="flex items-center gap-3.5"><img className="h-10 w-10 overflow-hidden rounded-full object-cover" src={avatarUrl} alt={`${user.firstName} ${user.lastName}`} /><div className="flex flex-col"><span className="text-base font-semibold">{user.firstName} {user.lastName}</span><LinkWithoutPrefetch href="/profile/account-settings" className={isSettingsPage ? "text-brand-primary" : ""}>{t("global.settings")}</LinkWithoutPrefetch>{!hasSubAccounts(user) && shouldShowSubAccountPage && <LinkWithoutPrefetch className={isSubaccountPage ? "text-brand-primary" : ""} href="/subaccounts">{t("header.user.profile.menu.sub_accounts")}</LinkWithoutPrefetch>}</div></div>}<MobileLanguageSwitcher /></div>{hasSubAccounts(user) && isWorkspaceOwner && <div className="flex flex-col"><FieldLabel labelClassName="mb-1" label={<div className="flex gap-1.5">{t("header.user.profile.menu.sub_accounts")}{shouldShowSubAccountPage && <LinkWithoutPrefetch href="/subaccounts" className="group self-center outline-hidden"><OpenInNewIcon className="main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary" /></LinkWithoutPrefetch>}</div>} /><SubAccountSelector /></div>}</div>;
  let t26;
  if ($[25] !== isDisabled || $[26] !== menuItems || $[27] !== user) {
    t26 = user && !isDisabled && menuItems.map(_temp);
    $[25] = isDisabled;
    $[26] = menuItems;
    $[27] = user;
    $[28] = t26;
  } else {
    t26 = $[28];
  }
  let t27;
  if ($[29] !== t26) {
    t27 = <div className="flex flex-col gap-8 py-4">{t26}</div>;
    $[29] = t26;
    $[30] = t27;
  } else {
    t27 = $[30];
  }
  let t28;
  if ($[31] !== hasWorkspaces || $[32] !== t) {
    t28 = hasWorkspaces && <FieldLabel labelClassName="mb-1" label={t("header.user.profile.menu.workspace")} />;
    $[31] = hasWorkspaces;
    $[32] = t;
    $[33] = t28;
  } else {
    t28 = $[33];
  }
  let t29;
  if ($[34] !== setIsOpen) {
    t29 = <WorkspaceSelector afterChange={() => setIsOpen(false)} className="text-text-primary" />;
    $[34] = setIsOpen;
    $[35] = t29;
  } else {
    t29 = $[35];
  }
  let t30;
  if ($[36] !== t28 || $[37] !== t29) {
    t30 = <div>{t28}{t29}</div>;
    $[36] = t28;
    $[37] = t29;
    $[38] = t30;
  } else {
    t30 = $[38];
  }
  let t31;
  if ($[39] !== isSupportImpersonation || $[40] !== t) {
    t31 = isSupportImpersonation && <a href="/dashboard/back/entry?pretend_this_user=_exit"><p className="cursor-pointer px-2">{t("header.exit_impersonation")}</p></a>;
    $[39] = isSupportImpersonation;
    $[40] = t;
    $[41] = t31;
  } else {
    t31 = $[41];
  }
  let t32;
  if ($[42] !== t) {
    t32 = t("header.user.profile.menu.logout");
    $[42] = t;
    $[43] = t32;
  } else {
    t32 = $[43];
  }
  let t33;
  if ($[44] !== t32) {
    t33 = <div className="flex items-center"><SideMenuItem item={{
        mobileIconRenderer: _temp2,
        href: "/logout",
        name: t32,
        isActive: _temp3,
        shouldRender: true
      }} /></div>;
    $[44] = t32;
    $[45] = t33;
  } else {
    t33 = $[45];
  }
  let t34;
  if ($[46] !== t30 || $[47] !== t31 || $[48] !== t33) {
    t34 = <div className="mt-auto flex flex-col gap-3">{t30}{t31}{t33}</div>;
    $[46] = t30;
    $[47] = t31;
    $[48] = t33;
    $[49] = t34;
  } else {
    t34 = $[49];
  }
  let t35;
  if ($[50] !== T4 || $[51] !== t24 || $[52] !== t25 || $[53] !== t27 || $[54] !== t34) {
    t35 = <T4 className={t19}>{t24}{t25}{t27}{t34}</T4>;
    $[50] = T4;
    $[51] = t24;
    $[52] = t25;
    $[53] = t27;
    $[54] = t34;
    $[55] = t35;
  } else {
    t35 = $[55];
  }
  let t36;
  if ($[56] !== T3 || $[57] !== t35) {
    t36 = <T3>{t35}</T3>;
    $[56] = T3;
    $[57] = t35;
    $[58] = t36;
  } else {
    t36 = $[58];
  }
  let t37;
  if ($[59] !== T2 || $[60] !== t12 || $[61] !== t36) {
    t37 = <T2 as={t12} enter={t13} enterFrom={t14} enterTo={t15} leave={t16} leaveFrom={t17} leaveTo={t18}>{t36}</T2>;
    $[59] = T2;
    $[60] = t12;
    $[61] = t36;
    $[62] = t37;
  } else {
    t37 = $[62];
  }
  let t38;
  if ($[63] !== T1 || $[64] !== t10 || $[65] !== t11 || $[66] !== t37) {
    t38 = <T1 className={t9} onClose={t10}>{t11}{t37}</T1>;
    $[63] = T1;
    $[64] = t10;
    $[65] = t11;
    $[66] = t37;
    $[67] = t38;
  } else {
    t38 = $[67];
  }
  let t39;
  if ($[68] !== T0 || $[69] !== isOpen || $[70] !== t38 || $[71] !== t8) {
    t39 = <T0 show={isOpen} as={t8}>{t38}</T0>;
    $[68] = T0;
    $[69] = isOpen;
    $[70] = t38;
    $[71] = t8;
    $[72] = t39;
  } else {
    t39 = $[72];
  }
  let t40;
  if ($[73] !== t3 || $[74] !== t39 || $[75] !== t4 || $[76] !== t7) {
    t40 = <div className={t3}>{t4}{t7}{t39}</div>;
    $[73] = t3;
    $[74] = t39;
    $[75] = t4;
    $[76] = t7;
    $[77] = t40;
  } else {
    t40 = $[77];
  }
  return t40;
};
export default SideMenu;
function _temp(item, idx) {
  return <SideMenuItem key={idx} item={item} />;
}
function _temp2() {
  return <LogoutIcon />;
}
function _temp3() {
  return false;
}